module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxIDEyLjVDMjEgMTcuNDcwNiAxNi45NzA2IDIxLjUgMTIgMjEuNUM3LjAyOTQ0IDIxLjUgMyAxNy40NzA2IDMgMTIuNUMzIDcuNTI5NDQgNy4wMjk0NCAzLjUgMTIgMy41IiBzdHJva2U9IiMwMDlBRUYiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNNyAxMS41TDExIDE1LjVMMjEgNS41IiBzdHJva2U9IiMwMDlBRUYiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bigengineering/icon1.svg
// module id = GnHR
// module chunks = 22